// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"2c1e743a","369":"0f20da7c","384":"1355ba67","441":"174fad16","453":"6f3ec818","525":"a140acd9","605":"fc9faaa3","648":"fb25ab97","721":"a285cbef","841":"dc2726db","856":"7936c73e","862":"c28ad586","957":"a464c194"}[chunkId] + ".chunk.js";
};